import React from "react";

import { Localized } from "../../translation";

import PlayerMeta from "./PlayerMeta";
import PlayerInfo from "./PlayerInfo";

const PlayerLeaderboard = () => (
  <>
    <PlayerMeta />
    <Localized id="player-leaderboard">
      <PlayerInfo>player-leaderboard</PlayerInfo>
    </Localized>
  </>
);

export default PlayerLeaderboard;
